import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const MediaService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/media/bulk", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/costcenter/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({
    search = "",
    mediaGroupId = "",
    page = 1,
    pageSize = 10,
  }) => {
    const params = new URLSearchParams({
      ...(search && { search }),
      ...(mediaGroupId && { mediaGroupId }),

      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/media?${params.toString()}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/media/${id}`);
    return response.data;
  },
  getCustomerBooking: async (id) => {
    const response = await apiService.get(`/customers/${id}/bookings`);
    return response.data;
  },

  guestUserList: async () => {
    const response = await apiService.get("/guestusers");
    return response.data;
  },
  getGuestDetail: async (id) => {
    const response = await apiService.get(
      `/costcenter/guest/withorderdetail/${id}`
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/media/${id}`);
    return response.data;
  },
};

export default MediaService;
